import { apiWrapper } from "@/services/api";
import store from "@/store/index";
import moment from "@/services/moment";

export const getMyLimitedExpressTickets = async (isPast) => {
  let response;
  try {
    const now = new Date();
    // 1回のAPIコールで取得するデータ件数
    const limit = 100;
    // ticketing_status=05 は無効チケットなので取得しない
    let url =
      `/mfitt/limited_express_tickets?ticketing_status=01,02,03,04&limit=` +
      limit;

    // isPast=trueで過去のチケット(AM3:00を基準に日付を切り替える)
    if (isPast) {
      // 当日は含んでしまうので、to_boarding_dateに1日前を指定
      const yesterday = moment(now)
        .subtract(3, "h")
        .subtract(1, "d")
        .format("YYYYMMDD");
      url += `&to_boarding_date=${yesterday}`;
    } else {
      const today = moment(now).subtract(3, "h").format("YYYYMMDD");
      url += `&from_boarding_date=${today}`;
    }

    // 未ログイン時のネイティブは不要なので、第4引数：isNotReCall:true
    response = await apiWrapper("GET", url, {}, true);

    // 保持するデータ(total-data-count)がlimitより多い場合はデータ取得を続ける
    if (response.headers["total-data-count"] > limit) {
      const times = Math.ceil(response.headers["total-data-count"] / limit);
      for (let i = 2; i <= times; i++) {
        const additonsData = await apiWrapper(
          "GET",
          url + `&page=${i}`,
          {},
          true,
        );
        response.data = response.data.concat(additonsData.data);
      }
    }
    console.log("getMyLimitedExpressTickets response.data :>> ", response.data);

    // 過去チケットでの表示の場合は、日付が新しい順
    const sortData = isPast
      ? sortByBoardingDateTime(response.data).reverse()
      : sortByBoardingDateTime(response.data);
    store.commit(
      "MFITT/setMyLimitedExpressTickets",
      filterByDisplayClient(sortData)
    );
  } catch (err) {
    // 取得できなかった場合は、空の配列をセット
    store.commit("MFITT/setMyLimitedExpressTickets", []);
    console.log('ERROR"" getMyLimitedExpressTickets():', err);
    throw err;
  }
  return response.data;
};

// 並び順を乗車日,発車時刻で昇順並び替え
const sortByBoardingDateTime = (element) => {
  if (element) {
    return element.slice().sort(function (a, b) {
      if (
        converter(a.boarding_date, a.departure_at) <
        converter(b.boarding_date, b.departure_at)
      )
        return -1;
      if (
        converter(a.boarding_date, a.departure_at) >
        converter(b.boarding_date, b.departure_at)
      )
        return 1;
      return 0;
    });
  }
};

const converter = (date, time) => {
  const dateNumbers = date.toString().split("-");
  const timeNumbers = time.match(/.{2}/g);
  return (
    dateNumbers[0] * 100000000 +
    dateNumbers[1] * 1000000 +
    dateNumbers[2] * 10000 +
    timeNumbers[0] * 100 +
    timeNumbers[1]
  );
};

const filterByDisplayClient = (dataArray) => {
  const displayTypes = ["app", "any"];
  return dataArray.filter((data) => displayTypes.includes(data.display_client));
}